<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import LecturesMenu from './LecturesMenu';
import config from '@/config/config';

export default {
  name: 'ComponentsCourseMaterials',
  components: {
    LecturesMenu,
  },
  computed: {
    ...mapState(config.app, [
      'course',
      'currentLectureIndex',
    ]),
    lectures() {
      return get(this, 'course.lectures', []);
    },
    lecture() {
      return !this.lectures[this.currentLectureIndex] ? {} : this.lectures[this.currentLectureIndex];
    },
    material() {
      return get(this, 'lecture.material', {});
    },
    isLast() {
      return this.currentLectureIndex >= (this.lectures.length - 1);
    },
    finalWords() {
      return get(this, 'course.finalWords', null);
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      'setCurrentCourse',
      'setCurrentLectureIndex',
    ]),
    next() {
      if (this.isLast && this.finalWords && this.finalWords.length > 0) {
        this.setCurrentCourse(this.flow.finish);
        return;
      }

      const nextIndex = this.currentLectureIndex + 1;

      if (this.lectures[nextIndex] && this.lectures[nextIndex].video) {
        this.setCurrentCourse(this.flow.video);
        this.setCurrentLectureIndex(nextIndex);
        return;
      }

      if (this.lectures[nextIndex] && this.lectures[nextIndex].material) {
        this.setCurrentCourse(this.flow.materials);
        this.setCurrentLectureIndex(nextIndex);
        return;
      }

      this.setCurrentCourse(this.flow.lecture);
      this.setCurrentLectureIndex(0);
    },
  },
};
</script>
<template>
    <div id="course-video">
        <LecturesMenu />
        <div class="wrapper">
            <button class="btn w-auto" @click="setCurrentCourse(flow.video)">
                powrót
            </button>
            <div v-html="material.content" class="mt-5 mb-5" />
            <div class="d-flex">
                <span class="font-weight-bold mr-3">Pobierz materiał:</span>
                <ul v-if="material.files">
                    <li v-for="(file, index) in material.files" :key="index">
                        <a :href="file.url" target="_blank">
                            {{ file.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <button class="btn w-auto mt-5" @click="next()">
                {{ !isLast ? 'Przejdź do następnej części' : 'Przejdź do następnego kroku' }}
            </button>
        </div>
    </div>
</template>
